import $ from 'cash-dom';
import HtmlHelper from '../../components/HtmlHelper';

let instance = null;

class VendorsPodium {
	constructor() {
		if (instance) {
			return instance;
		}

		this._$podiumVendorsHolder = $('.podium-vendors');
		this._$podiumHolder = this._$podiumVendorsHolder.closest('.podium');
		this._$podiumVendors = $('.podium-vendors .podium-vendor');
		this._$topChoice = null;
		this._$vendorsList = $('.vendors-list .ppc-single-vendor').not('.cross-chart-inside-list-vendor');
		this._$secondSubtitle = $('.vendors-list .second-subtitle');

		instance = this;
	}

	get podiumVendorCount() {
		return +this._$podiumVendorsHolder.data('count');
	}

	get topChoiceSelector() {
		return this._$podiumVendorsHolder.data('top-choice-selector');
	}

	get sortLeftToRight() {
		return !!+this._$podiumVendorsHolder.data('sort-left-to-right');
	}

	get needHeight() {
		return this._$podiumVendorsHolder.data('set-height');
	}

	get isPodiumVendorCount_3_AndNotSortLeftToRight() {
		return this.podiumVendorCount === 3 && this.visiblePodiumVendorsCount > 2 && !this.sortLeftToRight;
	}

	get visiblePodiumVendorsCount() {
		return this._$podiumVendorsHolder.find('.podium-vendor').not('.hidden').length;
	}

	/**
	 * @return {VendorsPodium}
	 */
	static getInstance() {
		if (!instance) {
			instance = new VendorsPodium();
		}

		return instance;
	}

	init() {
		if (this.needHeight) {
			this._setHeight();
		}
		$(document).on('filters-change', () => {
			this._$vendorsList = $('.vendors-list .ppc-single-vendor').not('.cross-chart-inside-list-vendor');
			this.updatePodiumVendors();
		});

		if ($('.vendors-list .ppc-single-vendor.visibly-hidden').length) {
			this._$vendorsList = $('.vendors-list .ppc-single-vendor').not('.cross-chart-inside-list-vendor');
			this.updatePodiumVendors();
		}

		this._setDataVisibleVendorsCount();
	}

	updatePodiumVendors() {
		if (this.needHeight) {
			this._setHeight();
		}
		if (!this._$podiumVendorsHolder.hasClass('update-on-filter')) {
			return;
		}

		const vendorIdsFromTheList = this._getVendorIdsFromTheList();

		this._hidePodiumIfNeeded(vendorIdsFromTheList);
		this._swapPodiumVendors(vendorIdsFromTheList);
		this._refillPodiumIndexes();

		if (this.isPodiumVendorCount_3_AndNotSortLeftToRight) {
			this._swapNodesAndUpdatePodiumVendors(this._$podiumVendors[0], this._$podiumVendors[1]);
		}

		if (this.visiblePodiumVendorsCount < 3) {
			this._$podiumVendorsHolder.addClass('center');
		} else {
			this._$podiumVendorsHolder.removeClass('center');
		}

		this._setDataVisibleVendorsCount();
	}

	_hidePodiumIfNeeded(vendorIds) {
		if (this._noVendorsInsidePodium(vendorIds)) {
			this._$podiumHolder.addClass('hidden');
			this._$secondSubtitle.hide();
		} else {
			this._$podiumHolder.removeClass('hidden');
			this._$secondSubtitle.show();
		}
	}

	_noVendorsInsidePodium(vendorIds) {
		let noVendorsInsidePodium = true;

		for (const vendorId of vendorIds) {
			if (this._$podiumVendorsHolder.find(`.podium-vendor[data-vendor-id="${vendorId}"]`).length) {
				noVendorsInsidePodium = false;
				break;
			}
		}

		return noVendorsInsidePodium;
	}

	_setDataVisibleVendorsCount() {
		this._$podiumVendorsHolder.data('visible-vendors-count', this.visiblePodiumVendorsCount);
	}

	_setHeight() {
		let maxHeight = this._$podiumVendorsHolder.data('max-height') || 0;
		const $items = this._$podiumVendorsHolder.find('.podium-vendor');

		if (!maxHeight) {
			$items.each(function() {
				maxHeight = Math.max(maxHeight, $(this).outerHeight(true));
			});

			this._$podiumVendorsHolder.data('max-height', maxHeight);
		}

		$items.css('height', `${maxHeight}px`);
	}

	_getVendorIdsFromTheList() {
		const vendorIdsFromTheList = [];

		this._$vendorsList.each((index, vendor) => {
			const $vendor = $(vendor);

			if (!$vendor.hasClass('hidden') && vendorIdsFromTheList.length < this.podiumVendorCount) {
				vendorIdsFromTheList.push($vendor.data('vendor-id'));
			}
		});

		return vendorIdsFromTheList;
	}

	_getNeededPodiumVendorsIndexes(vendorIdsFromTheList) {
		const neededPodiumVendorsIndexes = new Map();

		this._$podiumVendors.each((index, podiumVendor) => {
			const $podiumVendor = $(podiumVendor);
			const $topChoice = $podiumVendor.find(this.topChoiceSelector);

			if ($topChoice.length) {
				this._$topChoice = $topChoice.clone();
			}

			if (vendorIdsFromTheList.includes($podiumVendor.data('vendor-id'))) {
				neededPodiumVendorsIndexes.set($podiumVendor.data('vendor-id'), index);
			}
		});

		return neededPodiumVendorsIndexes;
	}

	_swapPodiumVendors(vendorIdsFromTheList) {
		for (let i = 0; i < vendorIdsFromTheList.length; ++i) {
			const neededVendorId = vendorIdsFromTheList[i];

			// we need new neededPodiumVendorsIndexes after each swap
			const neededPodiumVendorsIndexes = this._getNeededPodiumVendorsIndexes(vendorIdsFromTheList);
			const neededVendorIndex = neededPodiumVendorsIndexes.get(neededVendorId);

			if (i === neededVendorIndex || neededVendorIndex === undefined) {
				continue;
			}

			this._swapNodesAndUpdatePodiumVendors(this._$podiumVendors[i], this._$podiumVendors[neededVendorIndex]);
		}
	}

	_swapNodesAndUpdatePodiumVendors(node1, node2) {
		HtmlHelper.swapNodes(node1, node2);
		// we need new indexes from the new html after nodes swap
		this._$podiumVendors = this._$podiumVendorsHolder.find('.podium-vendor');
	}

	_refillPodiumIndexes() {
		const notHiddenVendorsCount = this._$vendorsList.parent().find('.ppc-single-vendor')
			.not('.hidden').not('.cross-chart-inside-list-vendor').length;

		this._$podiumVendors.each((i, podiumVendor) => {
			const $podiumVendor = $(podiumVendor);
			const $indexHolder = $podiumVendor.find('.list-index');

			$indexHolder.text(i + 1);

			if (i === 0) {
				$podiumVendor.addClass('first');
				$indexHolder.addClass('first');

				if (this._$topChoice) {
					$podiumVendor.prepend(this._$topChoice);
				}
			} else {
				$podiumVendor.removeClass('first');
				$indexHolder.removeClass('first');
				$podiumVendor.find(this.topChoiceSelector).remove();
			}

			if (i < this.podiumVendorCount && i < notHiddenVendorsCount) {
				$podiumVendor.removeClass('hidden');
			} else {
				$podiumVendor.addClass('hidden');
			}
		});
	}
}

export default VendorsPodium;